import { DISABLE_PAYMENT, DOMAIN_NAME } from "lib/constants/constants";
import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

import { useRequisitesStyles } from "./useRequisitesStyles";
import policyStore from "../../../store/policyStore";

type ModalState = "contacts" | "requisites" | "About" | "basket" | "";

type IMenuState = "main" | "offer" | "policy" | "menu" | "agreement";

interface IModalUIProps {
  isOpen: boolean;
  handleClose: (arg: ModalState) => () => void;
  className?: string;
}

const Requsites = ({ isOpen, className = "", handleClose }: IModalUIProps) => {
  const [menuState, setMenuState] = useState<IMenuState>("main");
  const { isPolicy, setPolicy } = policyStore();

  const onKey = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      setMenuState("main");
      handleClose("")();
    }
  };

  const onClickOverlay = (e: React.MouseEvent<HTMLElement>) => {
    handleClose("");

    if ((e.target as HTMLElement).classList.contains("req")) {
      setMenuState("main");
      handleClose("")();
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflowY = "hidden";
      window.addEventListener("keydown", onKey);
    } else {
      document.body.style.overflowY = "scroll";
      window.removeEventListener("keydown", onKey);
    }
    return () => {
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen]);

  return isOpen ? (
    <>
      <ModalContainerSC onClick={onClickOverlay} className={className}>
        <ContainerSC>
          {menuState === "main" ? (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "16px",
                }}>
                <button onClick={() => setMenuState("menu")}>Документы</button>
                <ReplyIconSC
                  onClick={() => {
                    setMenuState("main");
                    handleClose("")();
                  }}
                  src="ReplyIcon.svg"
                />
              </div>
              <TextSC>
                <p>ИП Кудрявцева Елена Викторовна</p>
                <p>Телефон: +79823577837</p>
                <p>Режим работы: Понедельник-Пятница, с 9:00 до 17:00</p>
                <p>
                  Адрес: 454006, г. Челябинск, ул. Российская, д. 59, 1 подъезд
                </p>
                <p>Email: helen_kud@bk.ru</p>
                <p>ИНН: 450101845134</p>
                <p>ОГРНИП: 32345000001836</p>
              </TextSC>
              <TitleSC>Политика возврата</TitleSC>
              <TextSC>
                <b>
                  <i>Отказ от заказа и возврат товара</i>
                </b>
                <br />
                <br />
                <p>
                  — Отказ от заказа до момента его получения Вы можете
                  отказаться от заказа заполнив форму обратной связи, или
                  обратившись по телефону: +79823577837.
                </p>
                <br />{" "}
                <p>
                  — Возврат товара надлежащего качества Вы можете вернуть товар
                  надлежащего качества в момент самовывоза со склада,
                  расположенного по адресу: 454006, г. Челябинск, ул.
                  Российская, д. 59, 1 подъезд. Необходимо предъявить товар в
                  ненарушенной оригинальной упаковке производителя (в том числе
                  должна быть не нарушена упаковка, сохранены товарный вид и
                  потребительские свойства).
                </p>{" "}
                <br />
                <p>
                  — Возврат товара ненадлежащего качества при обнаружении
                  недостатка (несоответствия требованиям к качеству) товара Вы
                  можете в течение 14 календарных дней обратиться по телефону:
                  +79823577837.
                </p>{" "}
                <br />
                <p>
                  При оформлении возврата любого товара Вам необходимо
                  предъявить следующие документы: фискальный чек или
                  счет-фактуру.
                </p>{" "}
                <br />
                <b>
                  <i>Возврат денежных средств</i>
                </b>{" "}
                <br /> <br />
                <p>
                  — Отказ от товара до получения если Вы отказались от заказа до
                  момента получения, предварительно оплатив его банковской
                  картой на сайте, денежные средства будут возвращены в течение
                  10 рабочих дней на банковскую карту, с которой был оплачен
                  заказ.
                </p>{" "}
                <br />
                <p>
                  — Отказ от товара после получения В случае оплаты заказа
                  наличными, денежные средства будут возвращены Вам
                  непосредственно при оформлении возврата. При оплате банковской
                  картой возврат денежных средств осуществляется в течение 10
                  рабочих дней на банковскую карту, с которой был оплачен заказ.
                </p>{" "}
                <br />
                <p>
                  — Возврат денежных средств при типе оплаты «Банковский
                  перевод» 1. В случае если Ваш заказ предоплачен, и Вы желаете
                  отказаться от товара, либо обнаружили фактическое отсутствие
                  товара в поставленном заказе в момент самовывоза, Вам следует
                  указать в графе товарной накладной «Товар» позиции, от
                  принятия которых Вы отказываетесь/ фактически отсутствуют:
                  количество, сумма, код причины отказа. Во всех экземплярах
                  товарной накладной указать, каким образом удобнее получить
                  возврат денежных средств: в счет платежа по следующему заказу
                  или переводом на расчетный счет (не дожидаясь размещения
                  следующего заказа).
                  <br /> <br /> 2. Направить письмо по электронной почте в адрес
                  поддержки сайта helen_kud@bk.ru с пожеланием о возврате
                  денежных средств на расчетный счет. Денежные средства будут
                  возвращены на расчетный счет в течение 10 рабочих дней с
                  момента получения соответствующего письма по электронной
                  почте.
                </p>
              </TextSC>
              <TitleSC>Условия доставки товаров</TitleSC>
              <TextSC>
                Доставка товаров и грузов осуществляется Почтой России, CDEK, а
                также самовывоз со склада. Доставка за счет средств покупателя.
              </TextSC>
              <TitleSC>Схема проезда</TitleSC>
              <br />
              <TextSC>
                454006, г. Челябинск, ул. Российская, д. 59, 1 подъезд
              </TextSC>
              <br />
              <br />
              <img
                style={{ width: "100%", marginBottom: "16px" }}
                src="/map.png"
                alt=" Подсказка по оплате."
              />
              <TitleSC>Инструкция по оплате банковской картой на сайте</TitleSC>
              <TextSC>
                <p>
                  Для онлайн оплаты на сайте принимаются банковские карты: Visa,
                  MasterCard, МИР. Прием платежей на сайте обеспечивает
                  процессинговый центр{" "}
                  <a
                    style={{ textDecoration: "underline" }}
                    href="https://paykeeper.ru/">
                    PayKeeper
                  </a>
                  . Для оплаты товара банковской картой при оформлении заказа
                  выберете способ оплаты: банковской картой. Обработка платежа
                  происходит на авторизованной странице банка, где Вам
                  необходимо ввести данные Вашей банковской карты:
                </p>{" "}
                <p>1. Номер карты</p>
                <p>2. Срок действия карты</p>
                <p>
                  Имя и фамилию владельца карты (латинскими буквами, как указано
                  на карте)
                </p>
                <p>
                  Код CVV2/CVC2 (Если на вашей карте код CVC / CVV отсутствует,
                  то, возможно, карта не пригодна для CNP транзакций (т.е. таких
                  транзакций, при которых сама карта не присутствует, а
                  используются её реквизиты), и вам следует обратиться в банк
                  для получения подробной информации.)
                </p>
                <br />
                <br />
                <img
                  style={{ width: "100%" }}
                  src="/reqCard.jpg"
                  alt=" Подсказка по оплате."
                />
                <br />
                <br />
                <p>
                  Если Ваша карта подключена к услуге 3D-Secure (технология
                  безопасного проведения интернет-платежей), Вы будите
                  автоматически переадресованы на страницу банка, выпустившего
                  карту, для прохождения процедуру аутентификации. Информацию о
                  правилах и методах дополнительной идентификации уточняйте в
                  банке, выдавшем Вам банковскую карту. <br /> <br />
                  Безопасность обработки интернет-платежей через платежный шлюз
                  банка гарантирована международным сертификатом безопасности
                  PCI DSS. Передача информации происходит с применением
                  технологии шифрования SSL. Эта информация не доступна
                  посторонним лицам.
                </p>
              </TextSC>
            </>
          ) : menuState === "menu" ? (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}>
                <button onClick={() => setMenuState("main")}>Назад</button>
                <ReplyIconSC
                  onClick={() => {
                    setMenuState("main");
                    handleClose("")();
                  }}
                  src="ReplyIcon.svg"
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  textAlign: "center",
                  gap: "4px",
                }}>
                <TextSC
                  style={{ cursor: "pointer" }}
                  onClick={() => setMenuState("offer")}>
                  Публичная оферта
                </TextSC>
                <TextSC
                  style={{ cursor: "pointer" }}
                  onClick={() => setMenuState("agreement")}>
                  Договор купли-продажи
                </TextSC>
                <TextSC
                  style={{ cursor: "pointer" }}
                  onClick={() => setMenuState("policy")}>
                  Политика конфиденциальности
                </TextSC>
              </div>
            </>
          ) : menuState === "offer" ? (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "16px",
                }}>
                <button onClick={() => setMenuState("menu")}>Назад</button>
                <ReplyIconSC
                  onClick={() => {
                    setMenuState("main");
                    handleClose("")();
                  }}
                  src="ReplyIcon.svg"
                />
              </div>
              <TextSC>
                <TitleSC>Публичная оферта</TitleSC>
                <p>
                  Настоящий документ является предложением ИП Кудрявцева Елена
                  Викторовна (далее – «Компания») в адрес зарегистрированных и
                  незарегистрированных пользователей (далее – «пользователи»,
                  «вы») сайта, расположенного на домене{" "}
                  <a href={`https://${DOMAIN_NAME}/`}>https://{DOMAIN_NAME}/</a>{" "}
                  и всех его поддоменах (далее – «сайт») заключить рамочный
                  договор оказания услуг (далее – «Договор») на указанных ниже
                  условиях (далее – «Оферта»).
                </p>
                <br />
                <p>
                  Термины и определения, применяемые в настоящем Договоре
                  термины и определения, используются в следующем их значении:
                </p>
                <br />
                <p>
                  «Сайт» одна или несколько логически связанных между собой
                  веб-страниц, объединенных общей тематикой, расположенный под
                  одним адресом, доступный пользователем с помощью интернет
                </p>
                <br />
                <p>
                  «Товары\Услуги» ассортимент продукции или услуг, размещенный
                  на сайте {DOMAIN_NAME}, предназначенный для реализации для
                  физических или юридических лиц путем оформления заказа онлайн
                </p>
                <br />
                <b>
                  <i>1.Предмет Договора</i>
                </b>
                <br />
                <br />
                <p>
                  1.1. Договор определяет общие условия обязательственных
                  отношений, возникающих между Компанией и Пользователем при
                  оказании Компанией реализации товаров с помощью сайта{" "}
                  {DOMAIN_NAME}.
                </p>
                <p>
                  1.2. Заключаемый Договор представляет собой договор с
                  открытыми условиями. Существенные условия каждой совершаемой
                  на сайте {DOMAIN_NAME} сделки по оказанию Услуг формируются
                  онлайн с помощью интерфейса сайта {DOMAIN_NAME}, посредством
                  которого Пользователь выбирает интересующий его товар.
                </p>
                <br />

                <b>
                  <i>2.Заключение Договора. Заказ Услуг</i>
                </b>
                <br />
                <br />
                <p>
                  2.1. Оферта считается акцептованной Пользователем, а Договор
                  между Компанией и Пользователем, заключенным с момента оплаты
                  пользователем товара по соответствующей сделке (в этом случае
                  она совершается одновременно с заключением Договора) или с
                  момента внесения аванса в счет оплаты заказываемых в будущем
                  товаров. Условия заключенного Договора применяются ко всем
                  последующим сделкам между Пользователем и Компанией. Договор
                  может быть заключен только с Пользователем, являющимся
                  дееспособным физическим лицом либо юридическим лицом или
                  индивидуальным предпринимателем.
                </p>
                <p>
                  2.2. Каждый заказ конкретных товаров в рамках Договора
                  является самостоятельной сделкой. Сделка во исполнение
                  настоящего Договора может быть заключена в отношении товаров,
                  доступных для заказа и оплаты на сайте {DOMAIN_NAME} в режиме
                  онлайн.
                </p>
                <p>
                  2.3. Оплата заказа признается акцептом Пользователя
                  предложения о заключении сделки на согласованных сторонами
                  условиях.
                </p>
                <p>
                  2.4. Пользователь оформляет каждый заказ товаров в
                  соответствии с условиями действующей редакции Оферты и
                  условиями соответствующего сервиса. Условия всех сервисов
                  {DOMAIN_NAME}, опубликованные на сайте {DOMAIN_NAME} в момент
                  заказа товаров, являются неотъемлемой частью оферты.
                </p>
                <p>
                  2.5. Совершая акцепт Оферты, Пользователь выражает согласие с
                  тем, что факт выполнения определенных действий на сайте
                  {DOMAIN_NAME}, в том числе с использованием профессиональных
                  технических инструментов, выполнение команд через интерфейс
                  сайта {DOMAIN_NAME} (нажатие кнопок, клики по ссылкам),
                  совершение платежа и иные подобные действия означают ваше
                  волеизъявление в отношении заказа товаров в соответствии с
                  указанными на сайте {DOMAIN_NAME} параметрами товаров и их
                  ценой.
                </p>
                <br />
                <b>
                  <i>3.Общие условия оказания Услуг</i>
                </b>
                <br />
                <br />
                <p>
                  3.1. Услуги оказываются на территории Российской Федерации.
                </p>
                <p>
                  3.2. При оплате заказа банковской картой обработка платежа
                  происходит на защищенной странице процессинговой системы,
                  которая прошла международную сертификацию. Это значит, что
                  конфиденциальные данные Пользователя (реквизиты карты,
                  регистрационные данные и др.) не поступают в Компанию, их
                  обработка полностью защищена, и никто не может получить
                  персональные и банковские данные Пользователя.
                </p>
                <p>
                  3.3. Предоставляемые на сайте {DOMAIN_NAME} товары могут
                  изменяться, дополняться, обновляться, в связи с чем их
                  использование предлагается в режиме «как есть», то есть в том
                  виде и объеме, в каком они предоставляются Компанией в момент
                  обращения Пользователя к услугам и сервисам {DOMAIN_NAME}.
                </p>
                <p>
                  3.4. Компания вправе направлять Пользователю по имеющимся у
                  нее контактным данным уведомления, связанные с исполнением
                  настоящего Договора или любой из заключенных в рамках Договора
                  сделок, включая оповещения о статусе оказания Услуги, способах
                  продления, изменениях условий оказания Услуг и иные
                  информационные сообщения, посредством смс- и push-сообщений,
                  электронной почты, звонков и сообщений в мессенджерах и
                  телефонных звонков.
                </p>
                <p>
                  3.5. Пользователь обязуется соблюдать при пользовании услугами
                  требования действующего законодательства Российской Федерации,
                  положения Договора, соответствующие условия выбранной Услуги
                  или сервиса и все иные правила сайта {DOMAIN_NAME}.
                </p>
                <p>
                  3.6. По требованию Компании Пользователь обязан предоставить
                  информацию и документы, необходимые для идентификации
                  пользователя в качестве стороны Договора, в частности при
                  направлении в адрес Компании заявлений, запросов и прочих
                  обращений, связанных с оказанием Услуг на сайте {DOMAIN_NAME}.
                  В целях идентификации частных пользователей Компанией могут
                  быть запрошены ФИО, серия и номер паспорта, скан-копия второй
                  и третьей страницы паспорта (второй разворот), адрес
                  электронной почты и номер телефона пользователя, используемые
                  для доступа к профилю. Кроме того, Компания вправе
                  самостоятельно проводить верификацию Пользователя в качестве
                  стороны по Договору путем проведения сверки, указанных
                  Пользователем в профиле реквизитов с реквизитами плательщика
                  по Договору, а также иными способами.
                </p>
                <p>
                  3.7. Компания, являясь оператором персональных данных,
                  осуществляет обработку персональных данных Пользователя с
                  целью исполнения договора согласно Политике
                  конфиденциальности, размещенной на сайте {DOMAIN_NAME}.
                </p>
                <br />
                <b>
                  <i>4. Стоимость и оплата товаров</i>
                </b>
                <br />
                <br />
                <p>
                  4.1. Стоимость выбранных товаров в российских рублях
                  отображается в интерфейсе сайта {DOMAIN_NAME} при оформлении
                  или оплате заказа, если иное не предусмотрено условиями
                  соответствующего сервиса или Услуги.
                </p>
                <p>
                  4.2. Стоимость включает НДС 20%, уплачиваемый на территории
                  РФ.
                </p>
                <p>
                  4.3. Оплата товаров осуществляется на условиях предоплаты по
                  ценам, действующим на момент совершения платежа.
                </p>
                <br />
                <b>
                  <i>5. Способы оплаты товаров</i>
                </b>
                <br />
                <br />
                <p>
                  5.1. Пользователь, являющийся юридическим лицом или
                  индивидуальным предпринимателем, может осуществлять оплату
                  товаров по Договору безналичным переводом денежных средств на
                  основании выставленного счета. Компания вправе установить
                  минимальный объем товаров, оплачиваемых данным способом.
                  Допускается также оплата с использованием корпоративной
                  банковской карты, оформленной на соответствующее юридическое
                  лицо или индивидуального предпринимателя.
                </p>
                <br />
                <b>
                  <i>6. Возврат денежных средств</i>
                </b>
                <br />
                <br />
                <p>
                  6.1. После оплаты товара пользователь имеет право в течение 24
                  часов вернуть денежные средства, написав в службу поддержки,
                  контакты которой размещены на странице сайта {DOMAIN_NAME}{" "}
                  (раздел покупателям), с адреса электронной почты, указанной
                  при регистрации либо оплате, письмо с просьбой сделать
                  возврат, указав мотивированную причину отказа. Если подобной
                  заявки в течении 24 часов после оплаты товара не поступило,
                  Компания оставляет за собой право не возвращать оплаченную
                  сумму.
                </p>
                <p>
                  6.2. Компания оставляет за собой право отказать в частичном
                  возврате денежных средств без объяснения причин и
                  рассматривает это в частном порядке по письменному заявлению
                  от Пользователя.
                </p>
                <p>
                  6.3. Ответственность за получение любых документов (в том
                  числе актов, сообщений, уведомлений) вышеуказанными способами
                  лежит на Пользователе. Компания не несет ответственности за
                  задержку или неполучение Пользователем документов, если это
                  явилось результатом неисправности систем связи,
                  действия/бездействия провайдеров, операторов связи, утраты
                  Пользователем доступа к профилю или иных обстоятельств,
                  находящихся вне зоны контроля Компании.
                </p>
                <br />
                <b>
                  <i>7. Ответственность</i>
                </b>
                <br />
                <br />
                <p>
                  7.1. Компания обязуется предпринимать все разумные усилия для
                  надлежащего оказания Услуг, однако не отвечает и не
                  компенсирует убытки пользователя в случае, если Пользователь
                  не может воспользоваться Услугами по следующим причинам:
                </p>
                <ul>
                  <li>
                    технологические неисправности каналов связи общего
                    пользования, посредством которых осуществляется доступ к
                    товарам, утраты Пользователем доступа в интернет по любой
                    причине, ошибки, пропуски, перерывы в работе или передаче
                    данных, дефекты линий связи и иные технические сбои;
                  </li>
                  <li>
                    несанкционированное вмешательство в работу сайта{" "}
                    {DOMAIN_NAME}
                    третьих лиц, включая хакерские, DDoS-атаки, действия
                    вирусных программ и иные нарушения работы сайта{" "}
                    {DOMAIN_NAME};
                  </li>
                  <li>при наступлении обстоятельств непреодолимой силы.</li>
                </ul>
                <p>
                  7.2. В случае причинения убытков Пользователю по вине Компании
                  ответственность определяется в порядке, предусмотренном
                  законодательством РФ. При этом ответственность Компании перед
                  Пользователями, сайт {DOMAIN_NAME} для предпринимательской и
                  иной профессиональной деятельности, определяется в размере, не
                  превышающем стоимость заказанной и оплаченной Пользователем,
                  но не полученной по вине Компании.
                </p>
                <p>
                  7.3. Компания не отвечает перед Пользователем за убытки,
                  возникшие у Пользователя не по вине Компании, в том числе в
                  связи с нарушением Пользователем правил сайта {DOMAIN_NAME}.
                </p>
                <p>
                  7.4. Компания не несет ответственности за перевод или
                  поступление денежных средств Пользователя в оплату товаров.
                  Безопасность, конфиденциальность, а также иные условия
                  использования выбранных Пользователем способов оплаты
                  определяются соглашениями между Пользователем и
                  соответствующими организациями по приему платежей.
                </p>
                <br />
                <b>
                  <i>8. Рассмотрение претензий</i>
                </b>
                <br />
                <br />
                <p>
                  8.1. Отношения Сторон, вытекающие из настоящего Договора, а
                  также тесно связанные с ними, регулируются действующим
                  законодательством РФ.
                </p>
                <p>
                  8.2. Споры, возникшие в рамках настоящего Договора,
                  рассматриваются и разрешаются в арбитражном суде г.
                  Челябинска.
                </p>
                <p>
                  8.3. До обращения в суд Пользователь с профилем юридического
                  лица или индивидуального предпринимателя должен соблюсти
                  внесудебный порядок разрешения споров, направив в адрес
                  Компании письменную претензию, с приложением документов,
                  подтверждающих обстоятельства и требования, на которые
                  ссылается Пользователь. Срок рассмотрения таких претензий
                  составляет не более 30 дней с момента получения претензии
                  Компанией.
                </p>
                <br />
                <b>
                  <i>9.Прочие условия</i>
                </b>
                <br />
                <br />
                <p>
                  9.1. Договор вступает в силу с момента его заключения в
                  порядке, указанном в разделе 2 Оферты, и действует в течение
                  неопределенного срока до момента его прекращения в
                  соответствии с Договором и законодательством.
                </p>
                <p>
                  9.2. Компания вправе изменять и/или дополнять Оферту в той
                  мере, в какой это допускается законодательством, а также
                  отозвать Оферту в любое время. Датой изменения Оферты является
                  дата публикации на сайте {DOMAIN_NAME} новой редакции Оферты.
                  Вы должны ознакомиться с действующей редакцией Оферты,
                  размещенной на сайте {DOMAIN_NAME}, и с условиями каждой
                  сделки до заключения Договора и совершения сделки.
                </p>
                <p>
                  9.3. Заказ товаров и совершение Пользователем сделки в рамках
                  Договора после вступления в силу изменений в Оферте означает,
                  что стороны пришли к согласию о внесении соответствующих
                  изменений и/или дополнений в Договор. Такие изменения в
                  Договоре не применяются к товарам, заказанным и оплаченным
                  Пользователем до вступления в силу изменений в Оферте.
                </p>
              </TextSC>
            </>
          ) : menuState === "policy" ? (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "16px",
                }}>
                <button onClick={() => setMenuState("menu")}>Назад</button>
                <ReplyIconSC
                  onClick={() => {
                    setMenuState("main");
                    handleClose("")();
                  }}
                  src="ReplyIcon.svg"
                />
              </div>
              <TextSC>
                <TitleSC>Политика конфиденциальности</TitleSC>
                <p>
                  Настоящая Политика определяет порядок, условия обработки
                  персональных данных пользователей Интернет-сайта https://
                  {DOMAIN_NAME}/ (далее - Сайт) и устанавливает требования по
                  обеспечению безопасности персональных данных пользователей
                  Администрацией Сайта.
                </p>
                <br />
                <p>
                  Политика разработана и реализуется в соответствии c
                  действующим национальным законодательством в сфере
                  персональных данных.
                </p>
                <br />
                <b>Определения</b>
                <br />
                <br />
                <p>
                  <b>Персональные данные</b> – любая информация, относящаяся к
                  прямо или косвенно определенному или определяемому физическому
                  лицу (гражданину). К такой информации, могут относиться:
                  Ф.И.О., год, месяц, дата и место рождения, почтовый адрес,
                  адрес электронной почты, номер телефона, сведения о семейном,
                  социальном, имущественном положении, сведения об образовании,
                  профессии, доходах, сведения о состоянии здоровья, а также
                  другая информация.
                </p>
                <br />
                <p>
                  <b>Обработка персональных данных</b> – любое действие с
                  персональными данными, совершаемое с использованием средств
                  автоматизации или без использования таких средств. К таким
                  действиям могут относиться: сбор, получение, запись,
                  систематизация, накопление, хранение, обновление, изменение,
                  извлечение, использование, передача (распространение,
                  предоставление, доступ), обезличивание, блокирование,
                  удаление, уничтожение персональных данных.
                </p>
                <br />
                <p>
                  <b>Пользователь</b> – физическое лицо, получающее доступ к
                  функционалу Сайта.
                </p>
                <br />
                <p>
                  <b>Администрация Сайта</b> – ИП Кудрявцева Елена Викторовна,
                  ИНН 450101845134, ОГРНИП 32345000001836. Адрес: 454006, г.
                  Челябинск, ул. Российская, д. 59, 1 подъезд.
                </p>
                <br />
                <p>
                  <b>1.</b> Обработка персональных данных пользователей Сайта
                  производится с соблюдением следующих принципов:
                </p>
                <ul>
                  <li>законности;</li>
                  <li>
                    ограничения обработки персональных данных достижением
                    конкретных, заранее определенных и законных целей;
                  </li>
                  <li>
                    недопущения обработки персональных данных, несовместимой с
                    целями сбора персональных данных;
                  </li>
                  <li>
                    недопущения объединения баз данных, содержащих персональные
                    данные, обработка которых осуществляется в целях,
                    несовместимых между собой.
                  </li>
                </ul>
                <br />
                <p>
                  <b>2.</b> В процессе обработки персональных данных
                  пользователей со стороны Администрации Сайта предпринимаются
                  необходимые и достаточные правовые, организационные и
                  технические меры для защиты персональных данных от
                  неправомерного или случайного доступа к ним, уничтожения,
                  изменения, блокирования, копирования, предоставления,
                  распространения персональных данных, а также от иных
                  неправомерных действий в отношении персональных данных.
                </p>
                <br />
                <p>
                  <b>3.</b> При обработке персональных данных пользователей
                  используются технические средства и технологические решения,
                  направленные на обезличивание субъектов персональных данных
                  при доступе к содержащей персональные данные информации лиц,
                  непосредственно задействованных в процессе обработки
                  персональных данных.
                </p>
                <br />
                <p>
                  <b>4.</b> Персональные данные пользователей хранятся на
                  собственных серверах Компании в полном соответствии с
                  правовыми и нормативно-техническими требованиями,
                  установленными действующим законодательством.
                </p>
                <br />
                <p>
                  <b>5.</b> Администрация Сайта не осуществляет обработку
                  биометрических и специальных категорий персональных данных
                  пользователей.
                </p>
                <br />
                <p>
                  <b>6.</b> При изменении своих персональных данных пользователь
                  соглашается, что такое изменение происходит на тех же
                  условиях, что и первоначальное предоставление им своих
                  персональных данных, не требует оформления дополнительного
                  согласия, и измененные персональные данные обрабатываются в
                  том же порядке, что и первоначально предоставленные
                  персональные данные.
                </p>
                <br />
                <p>
                  <b>7.</b> Администрация Сайта гарантирует и обеспечивает
                  полную конфиденциальность персональных данных пользователей,
                  обрабатываемых при предоставлении доступа к функционалу Сайта,
                  за исключением случаев, прямо предусмотренных настоящей
                  Политикой или действующим законодательством.
                </p>
                <br />
                <p>
                  <b>8.</b> Администрация Сайта осуществляет обработку только
                  тех персональных данных, которые необходимы для доставки
                  товаров пользователю, оказания услуг пользователю, а также для
                  надлежащего исполнения договоров, заключаемых с
                  пользователями:
                </p>
                <ul>
                  <li>
                    Фамилия, имя, отчество (при наличии) — для целей
                    идентификации пользователя при заключении договора
                    купли-продажи.
                  </li>
                  <li>
                    Телефонный номер — для цели осуществления оперативной связи
                    с пользователем по вопросам, связанным с обработкой заказов,
                    доставкой товаров, приобретённых пользователем на Сайте,
                    информированием по вопросам работы Сайта.
                  </li>
                  <li>
                    Адрес электронной почты — для целей направления пользователю
                    чеков и иных документов и информации, связанных с
                    приобретением товаров на Сайте и необходимых для
                    подтверждения факта заключения договора купли-продажи и
                    получения приобретённых товаров в пунктах выдачи заказов
                    службы доставки, а также для цели осуществления
                    информационных, новостных и рекламных рассылок в адрес
                    пользователя.
                  </li>
                  <li>
                    Почтовый адрес – только в случаях доставки пользователям
                    товаров, приобретённых ими на Сайте.
                  </li>
                </ul>
                <br />
                <p>
                  <b>9.</b> Осуществление информационных, новостных и рекламных
                  рассылок в адрес пользователя производится Администрацией
                  Сайта только в том случае, если имеется согласие пользователя
                  на получение таких рассылок. Пользователь в любой момент может
                  отказаться от любых рассылок, на которые он был подписан или
                  иным образом давал свое согласие.
                </p>
                <br />
                <p>
                  <b>10.</b> Администрация Сайта вправе передавать персональные
                  данные пользователей третьим лицам в следующих случаях:
                </p>
                <ol>
                  <li>
                    Пользователь явно выразил свое согласие на такие действия.
                  </li>
                  <li>
                    Передача необходима для исполнения договора, заключенного с
                    пользователем.
                  </li>
                  <li>Передача предусмотрена действующим законодательством.</li>
                </ol>
                <br />
                <p>
                  <b>11.</b> Пользователь имеет право в любой момент потребовать
                  от Администрации Сайта прекращения обработки его персональных
                  данных.
                </p>
                <br />
                <p>
                  <b>12.</b> Для целей статистической обработки информации,
                  оптимизации и дальнейшего развития функционала Сайта создаются
                  и используются файлы «cookie», фиксируются сведения о сетевых
                  адресах, с которых пользователями производится регистрация и
                  авторизация на Сайте, а также может сохраняться информация о
                  действиях пользователей, совершаемых ими в процессе
                  использования функционала Сайта, в том числе с помощью
                  специализированных программных средств (Яндекс.Метрика, VK
                  Реклама).
                </p>
                <br />
                <p>
                  <b>13.</b> Персональные данные пользователей обрабатываются в
                  течение 5 лет с момента заключения последнего договора с
                  пользователем для целей осуществления бухгалтерского и
                  налогового учета в соответствии со ст. 23 Налогового кодекса
                  Российской Федерации, ст. 29 Федерального Закона «О
                  бухгалтерском учете» № 402-ФЗ.
                </p>
                <br />
                <p>
                  <b>14.</b> По окончании срока обработки, в том числе по
                  требованию пользователя, персональные данные пользователей
                  удаляются из информационных систем Администрации Сайта.
                </p>
                <br />
                <label>
                  <input
                    type={"checkbox"}
                    checked={isPolicy}
                    onChange={setPolicy}
                  />{" "}
                  Согласен на обработку персональных данных
                </label>
              </TextSC>
            </>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "16px",
                }}>
                <button onClick={() => setMenuState("menu")}>Назад</button>
                <ReplyIconSC
                  onClick={() => {
                    setMenuState("main");
                    handleClose("")();
                  }}
                  src="ReplyIcon.svg"
                />
              </div>
              <TextSC>
                <TitleSC>
                  ДОГОВОР КУПЛИ-ПРОДАЖИ ТОВАРОВ В ИНТЕРНЕТ-МАГАЗИНЕ
                </TitleSC>
                <p>
                  <b>Продавец</b> — Индивидуальный предприниматель Кудрявцева
                  Елена Викторовна ОГРН 323450000018362, ИНН 450101845134
                </p>
                <br />
                <p>
                  <b>Покупатель</b> — любое полностью дееспособное физическое
                  лицо, акцептировавшее настоящую публичную оферту (договор) на
                  приведенных ниже условиях.
                </p>
                <br />
                <p>
                  <b>Интернет-магазин</b> — официальный интернет-магазин
                  Продавца, расположенный по адресу{" "}
                  <a href={`https://${DOMAIN_NAME}/`}>https://{DOMAIN_NAME}/</a>
                  . Понятия Интернет-магазин и Сайт являются равносильными и
                  трактуются аутентично по контексту ниже.
                </p>
                <br />
                <p>
                  <b>Товар</b> — объект материального мира, не изъятый из
                  гражданского оборота и предлагаемый к продаже в
                  Интернет-магазине.
                </p>
                <br />
                <p>
                  <b>Заказ</b> – Товар и услуги, согласованные Покупателем и
                  Продавцом, относительно которых у Покупателя и Продавца
                  возникают взаимные обязательства на согласованных Покупателем
                  и Продавцом условиях.
                </p>
                <br />
                <b>
                  <i>2. ОБЩИЕ УСЛОВИЯ.</i>
                </b>
                <br />
                <br />
                <p>
                  2.1. Настоящий договор (далее по тексту – «Договор»), а также
                  информация о Товаре, представленная на Сайте, являются
                  публичной офертой в соответствии со ст.435 и ч.2 ст.437
                  Гражданского кодекса РФ.
                </p>
                <p>2.2. В соответствии с Договором:</p>
                <p>
                  1) Продавец обязуется передать в собственность Покупателя
                  заказанный (согласованный Покупателем и Продавцом) Товар;
                </p>
                <p>
                  2) Покупатель обязуется принять и оплатить заказанный Товар и
                  его доставку.
                </p>
                <p>
                  2.3. Цены на Товар определяются Продавцом в одностороннем
                  бесспорном порядке и указываются на страницах
                  Интернет-магазина. Цена Товара определяется в рублях
                  Российской Федерации и включает в себя налог на добавленную
                  стоимость.
                </p>
                <p>
                  2.4. Право собственности на заказанный Товар переходит к
                  Покупателю при доставке транспортными компаниями - с момента
                  передачи Продавцом Товара в транспортную компанию.
                </p>
                <p>
                  Риск случайной гибели или повреждения Товара переходит к
                  Покупателю с момента фактической передачи Товара Покупателю.
                </p>
                <p>
                  2.5. Акцептом Договора является момент размещения Покупателем
                  Заказа согласно Договору.
                </p>
                <p>
                  2.6. Размещение Заказа Покупателем осуществляется путем
                  совершения действий, указанных в Правилах продажи.
                </p>
                <p>
                  2.7. Продавец имеет право в одностороннем порядке вносить
                  изменения в Договор, в том числе изменять цены на Товар и
                  стоимость сопутствующих услуг, способы и сроки оплаты и
                  доставки Товара, помещая их на страницах Интернет-магазина.
                  Все изменения вступают в силу немедленно после указанной
                  публикации, и считаются доведенными до сведения Покупателя с
                  момента такой публикации.
                </p>
                <p>
                  2.8. Отзыв оферты (Договора) может быть осуществлён Продавцом
                  в любое время, но это не является основанием для отказа от
                  обязательств Продавца по уже заключённым договорам. Продавец
                  обязуется разместить уведомление об отзыве оферты в своем
                  Интернет-магазине, не менее чем за 12 часов до факта
                  наступления события отзыва (приостановки) действия оферты.
                </p>
                <br />
                <b>
                  <i>3. ОПЛАТА ЗАКАЗА.</i>
                </b>
                <br />
                <br />
                <p>
                  3.1. Оплата Заказа осуществляется в рублях Российской
                  Федерации.
                </p>
                <p>
                  3.2. Общая стоимость Заказа не включает стоимость заказанного
                  Товара и его доставку, за исключением случаев, когда выбранный
                  способ доставки позволяет произвести оплату доставки при
                  получении Товара, по согласованию с Покупателем.
                </p>
                <p>
                  3.3. Покупатель осуществляет предварительную оплату Заказа в
                  размере 100% общей стоимости Заказа, за исключением случаев,
                  когда выбранный способ доставки позволяет произвести оплату
                  Заказа при получении его Покупателем. Продавец оставляет за
                  собой право в одностороннем порядке определять способ и
                  порядок оплаты по конкретному Заказу.
                </p>
                <p>3.4. Способы оплаты Заказа определены в Правилах Продажи.</p>
                <p>
                  3.5. Датой оплаты считается дата поступления денежных средств
                  на расчетный счет Продавца согласно его платежным реквизитам,
                  указанным в разделе 1 настоящего Договора.
                </p>
                <p>
                  3.6. В случае оплаты электронными деньгами (банковская карта,
                  Яндекс.Деньги и др.) или переводом (через банк или Почтой
                  России) Продавец направляет Покупателю электронную копию чека
                  на указанный в заказе адрес электронной почты в день
                  поступления денежных средств на расчетный счет Продавца.
                </p>
                <br />
                <b>
                  <i>4. ДОСТАВКА ТОВАРА.</i>
                </b>
                <br />
                <br />
                <p>
                  4.1. Доставка Товара Покупателю осуществляется в пределах
                  территории Российской Федерации.
                </p>
                <p>
                  4.2. Стоимость доставки Товара по территории РФ определяется
                  Тарифами используемой службы доставки. Способы доставки Заказа
                  определены в Правилах Продажи.
                </p>
                <p>
                  4.3. Место передачи Товара Покупателю определяется по адресу,
                  указанному в размещенном Заказе.
                </p>
                <p>
                  4.4. Передача Товара Покупателю осуществляется только после
                  полной оплаты Покупателем стоимости Заказа.
                </p>
                <p>
                  4.5. Передача заказанного Товара Покупателю может
                  осуществляться в согласованном Покупателем и Продавцом пункте
                  выдачи Товара, в зависимости от выбранного способа доставки.
                </p>
                <br />
                <b>
                  <i>5. ВОЗВРАТ ТОВАРА.</i>
                </b>
                <br />
                <br />
                <p> 5.1. Возврат товара надлежащего качества. </p>
                <p>
                  1) Покупатель вправе отказаться от заказанного Товара в любое
                  время до его получения, а после получения Товара — в течение
                  14 дней, не считая дня покупки. Вернуть товар надлежащего
                  качества можно при соблюдении следующих условий:
                </p>
                <p>товар не был в употреблении;</p>
                <p>
                  сохранен товарный вид (этикетки, ярлыки, оригинальная упаковка
                  производителя) и потребительские свойства;
                </p>
                <p>
                  приложена копия квитанции (накладная) об оплате посылки с
                  заполненным бланком возврата.
                </p>
                <p>
                  2) Продавец возвращает Покупателю сумму оплаты за Заказ за
                  исключением расходов на доставку в течение 10 дней с даты
                  получения Продавцом письменного заявления Покупателя. Если
                  возврат связан с ошибкой Продавца, то возвращаются и расходы
                  на доставку.
                </p>
                <p> 5.2. Возврат товара ненадлежащего качества.</p>
                <p>
                  1) Покупатель вправе вернуть товар ненадлежащего качества и
                  потребовать возврата уплаченной суммы. Также он может
                  потребовать устранения недостатков, уменьшения цены или замены
                  товара.
                </p>
                <p>
                  2) Продавец обязан рассмотреть претензии и произвести возврат
                  денежных средств в течение 10 дней или заменить товар в
                  течение 7 дней с момента предъявления требования, если иное не
                  предусмотрено.
                </p>
                <br />
                <b>
                  <i>6. ПОРЯДОК РАЗРЕШЕНИЯ СПОРОВ. ПРИМЕНИМОЕ ПРАВО.</i>
                </b>
                <br />
                <br />
                <p>
                  6.1. К отношениям между Покупателем и Продавцом применяется
                  законодательство Российской Федерации.
                </p>
                <p>
                  6.2. Споры разрешаются путем переговоров. Если соглашение не
                  достигнуто, спор передается в суд в соответствии с
                  законодательством РФ.
                </p>
                <p>
                  6.3. Документы и переписка, связанные с исполнением Договора,
                  имеют равную юридическую силу с оригиналами при передаче через
                  Интернет или электронные средства связи.
                </p>
                <p>
                  6.4. Признание судом недействительности любого положения
                  Договора не влечет недействительность остальных положений.
                </p>
                <p>
                  6.5. Приложения к Договору являются его неотъемлемой частью.
                </p>
              </TextSC>
            </>
          )}
        </ContainerSC>
      </ModalContainerSC>
      {createPortal(
        <ModalBackdoorSC onClick={handleClose("")} />,
        document.querySelector("#root") as HTMLElement,
      )}
    </>
  ) : null;
};

const {
  ContainerSC,
  ModalBackdoorSC,
  ModalContainerSC,
  ReplyIconSC,
  TextSC,
  TitleSC,
} = useRequisitesStyles();

export default React.memo(Requsites);
